(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const sticky = document.querySelector('hdt-sticky-btn-atc[form]');
    const form = sticky && document.getElementById(sticky.getAttribute('form'));
    const stickyForm = sticky?.querySelector('form');
    const mainButton = form?.querySelector('[type="submit"][name="add"]');
    const button = sticky?.querySelector('[type="submit"][name="add"]');
    const mainBuyNow = form?.querySelector('[data-en-buy-now]');
    const stickyBuyNow = sticky?.querySelector('[data-en-sticky-buy-now]');
    const mainBuyNowStatus = form?.querySelector('[data-en-buy-now-status]');
    const stickyBuyNowStatus = sticky?.querySelector('[data-en-sticky-buy-now-status]');
    if (!form || !stickyForm || !mainButton || !button || sticky.dataset.enStickyReady) return;
    sticky.dataset.enStickyReady = 'true';
    const scope = form.closest('.hdt-section--feature-product') || form;
    let scheduled = false;
    let selectedVariant;
    const setText = (element, value) => {
      if (element && value && element.textContent !== value) element.textContent = value;
    };
    const syncForm = () => {
      for (const name of ['id', 'quantity']) {
        const source = form.elements.namedItem(name);
        const target = stickyForm.elements.namedItem(name);
        if (source && target) target.value = source.value;
      }
      const busy = mainButton.getAttribute('aria-busy') === 'true';
      button.disabled = mainButton.disabled || busy;
      button.setAttribute('aria-busy', String(busy));
      button.setAttribute('variant-state', mainButton.getAttribute('variant-state') || '');
      setText(button.querySelector('.hdt-btn-atc_text'), mainButton.querySelector('.hdt-btn-atc_text')?.textContent);
      if (stickyBuyNow) {
        stickyBuyNow.hidden = !mainBuyNow;
        stickyBuyNow.disabled = !mainBuyNow || mainBuyNow.disabled || busy;
        stickyBuyNow.setAttribute('aria-busy', String(Boolean(mainBuyNow?.getAttribute('aria-busy') === 'true')));
      }
      const price = [...scope.querySelectorAll('hdt-price[form]')]
        .find(element => element.getAttribute('form') === form.getAttribute('id'))
        ?.querySelector('.hdt-money')?.textContent;
      setText(sticky.querySelector('.hdt-sticky-atc__product-monney'), price);
      const variantControl = sticky.querySelector('[tag-select]');
      if (variantControl && selectedVariant) {
        setText(variantControl.querySelector('span:first-child'), selectedVariant.title);
        setText(variantControl.querySelector('span:nth-child(2)'), price ? ' — ' + price.trim() : '');
      }
    };
    const syncStickyAtc = () => {
      scheduled = false;
      syncForm();
      const isVisible = element => Boolean(element.getClientRects().length) &&
        getComputedStyle(element).visibility !== 'hidden';
      const modalOpen = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])')].some(isVisible);
      const chatButton = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button');
      const chatOpen = chatButton?.getAttribute('aria-expanded') === 'true';
      const previewOffset = document.getElementById('PBarNextFrame')
        ? Math.max(0, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--private-preview-bar-offset')) || 0) : 0;
      sticky.style.setProperty('--en-sticky-bottom', previewOffset + 'px');
      let chatSpace = 0;
      if (chatButton && isVisible(chatButton) && window.innerWidth < 768) {
        const chatRect = chatButton.getBoundingClientRect();
        const barTop = window.innerHeight - previewOffset - sticky.getBoundingClientRect().height;
        if (chatRect.bottom > barTop && chatRect.top < window.innerHeight - previewOffset) chatSpace = chatRect.right + 12;
      }
      sticky.style.setProperty('--en-sticky-left', Math.max(16, chatSpace) + 'px');
      const visible = Boolean(customElements.get('wrapp-hdt-pr-frm')) && form.getBoundingClientRect().bottom < 0 && !modalOpen && !chatOpen;
      sticky.dataset.enStickyVisible = String(visible);
      sticky.inert = !visible;
      document.body.classList.toggle('en-sticky-atc-visible', visible);
    };
    const scheduleSync = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(syncStickyAtc);
    };
    stickyForm.addEventListener('submit', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      syncForm();
      if (!customElements.get('wrapp-hdt-pr-frm') || button.disabled || mainButton.getAttribute('aria-busy') === 'true') return;
      form.requestSubmit(mainButton);
      syncForm();
    }, true);
    stickyBuyNow?.addEventListener('click', event => {
      event.preventDefault();
      syncForm();
      if (!mainBuyNow || stickyBuyNow.disabled) return;
      mainBuyNow.click();
      scheduleSync();
    });
    if (mainBuyNowStatus && stickyBuyNowStatus) {
      const syncBuyNowStatus = () => {
        if (stickyBuyNowStatus.innerHTML !== mainBuyNowStatus.innerHTML) {
          stickyBuyNowStatus.replaceChildren(...Array.from(mainBuyNowStatus.childNodes, node => node.cloneNode(true)));
        }
        stickyBuyNowStatus.hidden = mainBuyNowStatus.hidden || !mainBuyNowStatus.textContent;
        const previewStatusSpace = document.getElementById('PBarNextFrame') && !stickyBuyNowStatus.hidden
          ? stickyBuyNowStatus.getBoundingClientRect().height + 12 : 0;
        const rootStyle = document.documentElement.style;
        if (rootStyle.getPropertyValue('--en-preview-sticky-status-space') !== previewStatusSpace + 'px') {
          rootStyle.setProperty('--en-preview-sticky-status-space', previewStatusSpace + 'px');
        }
      };
      new MutationObserver(syncBuyNowStatus).observe(mainBuyNowStatus, { attributes: true, childList: true, characterData: true, subtree: true });
      new ResizeObserver(syncBuyNowStatus).observe(stickyBuyNowStatus);
      syncBuyNowStatus();
    }
    form.addEventListener('variant:change', event => {
      selectedVariant = event.detail?.variant;
      scheduleSync();
    });
    document.addEventListener('input', scheduleSync);
    document.addEventListener('change', scheduleSync);
    document.addEventListener('close', scheduleSync, true);
    document.addEventListener('toggle', scheduleSync, true);
    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    new MutationObserver(scheduleSync).observe(form, {
      attributes: true, childList: true, subtree: true, characterData: true,
      attributeFilter: ['disabled', 'aria-busy', 'variant-state', 'value']
    });
    new MutationObserver(scheduleSync).observe(document.body, {
      attributes: true, subtree: true,
      attributeFilter: ['open', 'aria-modal', 'hidden']
    });
    const containsModal = node => node.nodeType === 1 && (
      node.matches('dialog,[role="dialog"][aria-modal="true"]') ||
      node.querySelector('dialog,[role="dialog"][aria-modal="true"]')
    );
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(containsModal))) scheduleSync();
    }).observe(document.body, { childList: true, subtree: true });
    new MutationObserver(scheduleSync).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
    if (chatRoot) new MutationObserver(scheduleSync).observe(chatRoot, { attributes: true, subtree: true, attributeFilter: ['aria-expanded', 'hidden', 'style'] });
    new ResizeObserver(scheduleSync).observe(form);
    customElements.whenDefined('wrapp-hdt-pr-frm').then(scheduleSync);
    syncStickyAtc();
  })();

  } catch(e) { console.error(e); }
})();
})();
